<template>
    <v-app>
        <v-navigation-drawer v-model="drawer" app permanent>
            <!-- Logo Section -->
            <div class="logo-container">
                <h1 class="text-center">OSCE</h1>
            </div>

            <!-- Main Menu Items -->
            <v-list dense nav class="main-menu">
                <v-list-item v-for="item in menuItems" :key="item.title" link :to="item.route">
                    <v-list-item-icon class="listItemIcon">
                        <v-icon class="listIcon">{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="listContent">
                        <v-list-item-title class="listTitle">{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <!-- Bottom Menu Items -->
            <div class="bottom-fixed-menu">
                <v-list dense nav>
                    <v-list-item link @click="openReportDialog">
                        <v-list-item-icon class="listItemIcon">
                            <v-icon class="listIcon">mdi-help-circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="listContent">
                            <v-list-item-title class="listTitle">問題回報</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item @click="logout" class="logout-item">
                        <v-list-item-icon class="listItemIcon">
                            <v-icon class="listIcon">mdi-logout</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="listContent">
                            <v-list-item-title class="listTitle">登出</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </div>
        </v-navigation-drawer>
        
        <!-- 主要內容 -->
        <v-main class="main-content">
            <div class="d-flex justify-start align-start outliner">
                <router-view></router-view>
            </div>
        </v-main>
   
        <!-- 語音驗證框 -->
        <v-dialog v-model="showVoiceDialog" persistent max-width="400">
            <v-card class="voice-dialog">
                <v-card-title class="text-h6 mb-2">
                    語音功能確認
                </v-card-title>
                <v-card-text class="text-center pa-6">
                    <div class="text-h6 mb-4">請按下錄音鍵並清楚說出：</div>
                    <div class="text-h5 mb-6">麥克風測試</div>
                    
                    <div class="record-button-container">
                        <v-btn
                            :color="isRecording ? 'red' : 'primary'"
                            rounded
                            width="100"
                            height="100"
                            class="record-button"
                            @click="toggleRecording"
                            :disabled="isProcessing"
                        >
                            <v-icon size="48">
                                {{ isRecording ? 'mdi-stop' : 'mdi-microphone' }}
                            </v-icon>
                        </v-btn>
                    </div>

                    <div v-if="isProcessing" class="mt-6">
                        <v-progress-circular
                            indeterminate
                            color="primary"
                        ></v-progress-circular>
                        <div class="mt-2">正在處理中...</div>
                    </div>

                    <div v-if="recordingError" class="mt-4 red--text">
                        {{ recordingError }}
                        <v-btn
                            text
                            color="primary"
                            class="mt-2"
                            @click="resetRecording"
                        >
                            重新嘗試
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" max-width="1000px" rounded="lg">
                <v-card class="pa-6">
                    <div class="d-flex align-start">
                        <!-- Title Section -->
                        <div class="flex-grow-1">
                            <v-card-title class="text-h5 mb-4 text-left">
                                歡迎來到 OSCE
                                <br />
                                請設定帳號基本資料
                            </v-card-title>
                        </div>

                        <!-- Avatar Upload Section -->
                        <div class="avatar-upload" v-if="false">
                            <input type="file" ref="fileInput" accept="image/*" @change="onFileSelected" class="d-none">
                            <v-avatar size="100" class="avatar-preview" @click="$refs.fileInput.click()">
                                <v-img v-if="avatarPreview" :src="avatarPreview" alt="Avatar"></v-img>
                                <v-icon v-else size="40" color="grey">
                                    mdi-account
                                </v-icon>
                            </v-avatar>
                        </div>
                    </div>

                    <v-card-text style="padding-top: 4rem;">
                        <v-form>
                <v-row>
                                        <!-- 學校名稱 -->
                                        <v-col cols="12" md="3">
                        <v-text-field v-model="profile.school.name" label="學校名稱" outlined  :readonly="true"></v-text-field>
                    </v-col>
                    <!-- 系所名稱 -->
                    <v-col cols="12" md="3">
                        <v-text-field v-model="profile.department.name" label="系所名稱" outlined  :readonly="true"></v-text-field>
                    </v-col>
                    <!-- 年級 -->
                    <v-col cols="12" md="3">
                        <v-text-field v-model="profile.classYear.name" label="年級" outlined  :readonly="true"></v-text-field>
                    </v-col>
                    <!-- 班級 -->
                    <v-col cols="12" md="3">
                        <v-text-field v-model="profile.classGroup.name" label="班級" outlined  :readonly="true"></v-text-field>
                    </v-col>
                    <!-- 姓名 -->
                    <v-col cols="12" md="4">
                        <v-text-field v-model="profile.name" label="姓名" outlined  ></v-text-field>
                    </v-col>
                    <!-- 電話 -->
                    <v-col cols="12" md="4">
                        <v-text-field v-model="profile.phone" label="電話" outlined  ></v-text-field>
                    </v-col>
                    <!-- 信箱 -->
                    <v-col cols="12" md="4">
                        <v-text-field v-model="profile.email" label="信箱" outlined ></v-text-field>
                    </v-col>

                    <!-- 帳號 -->
                    <v-col cols="12" md="4">
                        <v-text-field v-model="profile.username" label="帳號" outlined ></v-text-field>
                    </v-col>
                    <!-- 密碼 -->
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="profile.password"
                            label="密碼"
                            :type="showPassword ? 'text' : 'password'"
                            outlined
                            :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                            @click:append="showPassword = !showPassword"
                        ></v-text-field>
                    </v-col>
                    <!-- 性別 -->
                    <v-col cols="12" md="4">
                        <v-select v-model="profile.sex" :items="sexOptions" label="性別" outlined ></v-select>
                    </v-col>
                </v-row>
            </v-form>
                    </v-card-text>

                    <v-card-actions class="pt-6">
                        <v-spacer></v-spacer>
                        <v-btn color="black" dark height="44" @click="submitForm"
                            style="border-radius: 10px;width: 15rem;">
                            完成
                        </v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        <v-dialog v-model="reportDialog" max-width="1000">
            <v-card class="pa-4" style="background-color: #F8F8F8; border-radius: 16px;">
                <v-card-title class="text-h6 mb-3 grey--text text--darken-2">
                    問題回報
                </v-card-title>
                <v-card-text>
                    <!-- 可點擊的黑色背景圖片預覽區域 -->
                    <div 
                        class="preview-area mb-4" 
                        style="background-color: #000000; border-radius: 12px; height: 600px; width: 100%; cursor: pointer; overflow: hidden;"
                        @click="handleImageAreaClick"
                    >
                        <!-- 簡化為單張圖片顯示 -->
                        <div v-if="reportImages.length" style="height: 100%; width: 100%; display: flex; align-items: center; justify-content: center;">
                            <v-img
                                :src="reportImages[0].preview"
                                style="max-height: 100%; max-width: 100%; object-fit: contain;"
                                class="rounded"
                            ></v-img>
                        </div>
                        <!-- 當沒有圖片時顯示上傳提示 -->
                        <div v-else class="upload-hint">
                            <v-icon color="grey" size="40">mdi-image-plus</v-icon>
                            <div class="mt-2 grey--text">點擊上傳圖片</div>
                        </div>
                    </div>

                    <!-- 問題內容輸入區 -->
                    <v-textarea
                        v-model="reportContent"
                        outlined
                        placeholder="請輸入回報內容"
                        rows="4"
                        background-color="white"
                        hide-details
                        class="rounded-lg"
                        style="border-radius: 12px;"
                    ></v-textarea>

                    <!-- 底部按鈕區域 -->
                    <div class="d-flex justify-space-between mt-4">
                        <v-btn
                            color="grey lighten-2"
                            @click="closeReportDialog"
                            class="rounded-lg"
                            elevation="0"
                            height="40"
                        >
                            關閉
                        </v-btn>

                        <v-btn
                            color="black"
                            dark
                            @click="submitReport"
                            class="rounded-lg"
                            elevation="0"
                            height="40"
                        >
                            送出
                        </v-btn>
                    </div>

                    <!-- 隱藏的檔案輸入 -->
                    <input
                        type="file"
                        ref="imageInput"
                        accept="image/*"
                        multiple
                        @change="onImageSelected"
                        class="d-none"
                    >
                </v-card-text>
            </v-card>
        </v-dialog>

    </v-app>
</template>

<script>
import AuthService from '../services/auth.service'
import html2canvas from 'html2canvas';
import ReportService from '../services/report.service';
import userService from '../services/user.service'
import VoiceService from '../services/voice.service'
export default {
    name: 'StudentView',
    data() {
        return {
            drawer: true,
            menuItems: [
                {
                    title: '個人資料',
                    icon: 'mdi-account',
                    route: '/student/profile'
                },
                {
                    title: '測驗',
                    icon: 'mdi-file-document',
                    route: '/student/exam'
                },
                {
                    title: '虛擬病患',
                    icon: 'mdi-hospital-box',
                    route: '/student/patients'
                },
                {
                    title: '虛擬人互動',
                    icon: 'mdi-hospital-box',
                    route: '/student/patientsv2'
                }
            ],
            dialog: false,
            profile: {
                name: '',
                phone: '',
                email: '',
                username: '',
                password: '',
                school: {
                    name: '',
                    contactPerson: '',
                },
                department: {
                    name: '',
                },
                classYear: {
                    name: '',
                },
                classGroup: {
                    name: '',
                },
                avatarUrl: null // 頭像URL
            },
            showPassword: false,
            showVoiceDialog: false,
            isRecording: false,
            isProcessing: false,
            recordingError: '',
            mediaRecorder: null,
            audioChunks: [],
            reportDialog: false,
            reportContent: '',
            reportImages: [],
            imagePreview: null,
            sexOptions:['男','女','其他']
        }
    },
    methods: {
        init() {
            if (localStorage.getItem("authenticated")) {
                AuthService.verifyToken()
                    .then(() => {
                    })
                    .catch(() => {
                        localStorage.removeItem("authenticated")
                        this.$router.push('/')
                    })
            }else{
                this.$router.push('/')
            }
            userService.getUserInfo(localStorage.getItem('user_id')).then((res) => {
                if (res.data.userType !== undefined) {
                        if (res.data.userType == 0) {
                            this.$router.push("/admin");
                         
                        } else if (res.data.userType == 1) {
                            this.$router.push("/school");
                          
                        } else if (res.data.userType == 2) {
                            this.$router.push("/teacher");
                           
                        } 
                }
                this.profile = res.data 
                localStorage.setItem('name', this.profile.name)
                if(!this.profile.editedProfile){
                    this.dialog = true
                }else{
                    this.showVoiceDialog = false
                }
            })
        },
        logout() {
            // 處理登出邏輯
            AuthService.logout()
                .then(() => {
                    console.log("logout")
                    this.$router.push('/')
                })
                .catch(err => {
                    console.log(err)
                    alert(err.message)
                })
        },
        submitForm() {
            if(this.profile.password === ''){
                return alert('密碼不能為空')
            }   
            if(this.profile.name === ''){
                return alert('姓名不能為空')
            }
            if(this.profile.phone === ''){
                return alert('電話不能為空')
            }
            if(this.profile.email === ''){
                return alert('信箱不能為空')
            }
            if(this.profile.username === ''){
                return alert('帳號不能為空')
            }
            if(this.profile.school === null){
                return alert('學校名稱不能為空')
            }
            if(this.profile.department === null){
                return alert('系所名稱不能為空')
            }
            if(this.profile.classYear === null){
                return alert('年級不能為空')
            }
            if(this.profile.classGroup === null){
                return alert('班級不能為空')
            }
            this.profile.editedProfile = true
            userService.updateUserInfo(localStorage.getItem('user_id'), this.profile).then(() => {
                this.init()
                this.dialog = false
                this.showVoiceDialog = true
            })
        },
        async toggleRecording() {
            if (!this.isRecording) {
                try {
                    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                    this.mediaRecorder = new MediaRecorder(stream);
                    this.audioChunks = [];
                    
                    this.mediaRecorder.ondataavailable = (event) => {
                        this.audioChunks.push(event.data);
                    };

                    this.mediaRecorder.onstop = async () => {
                        try {
                            this.isProcessing = true;
                            const audioBlob = new Blob(this.audioChunks, { type: 'audio/mp3' });
                            
                            // 發送到音頻檢查 API
                            const response = await VoiceService.audioCheck(audioBlob);
                            
                            if (response.data.check_result === 1) {
                                // 驗證成功
                                this.showVoiceDialog = false;
                                this.profile.voiceVerified = true;
                                await userService.updateUserInfo(localStorage.getItem('user_id'), this.profile);
                            } else {
                                // 驗證失敗
                                this.recordingError = '語音驗證失敗，請重新嘗試';
                            }
                        } catch (error) {
                            console.error('Audio check error:', error);
                            this.recordingError = '語音驗證發生錯誤，請重新嘗試';
                        } finally {
                            this.isProcessing = false;
                            this.isRecording = false;
                        }
                    };

                    this.mediaRecorder.start();
                    this.isRecording = true;
                    this.recordingError = '';
                } catch (err) {
                    console.error('錄音權限獲取失敗:', err);
                    this.recordingError = '請允許使用麥克風進行錄音';
                }
            } else {
                this.mediaRecorder.stop();
                this.mediaRecorder.stream.getTracks().forEach(track => track.stop());
            }
        },
        resetRecording() {
            this.isRecording = false;
            this.isProcessing = false;
            this.recordingError = '';
            this.audioChunks = [];
            if (this.mediaRecorder && this.mediaRecorder.stream) {
                this.mediaRecorder.stream.getTracks().forEach(track => track.stop());
            }
        },
        onImageSelected(event) {
            const file = event.target.files[0];
            if (file && file.type.startsWith('image/')) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.reportImages = [{
                        file: file,
                        preview: e.target.result
                    }];
                };
                reader.readAsDataURL(file);
            }
        },
        removeImage(index) {
            this.reportImages.splice(index, 1);
        },
        closeReportDialog() {
            this.reportDialog = false;
            this.reportContent = '';
            this.reportImages = [];
        },
        submitReport() {
            if(this.reportContent == '') {
                alert('請輸入回報內容')
                return
            }
            // 建立 FormData 物件
            const formData = new FormData();
            formData.append('description', this.reportContent);
            
            // 如果有圖片，只附加第一張
            if (this.reportImages.length > 0) {
                formData.append('report', this.reportImages[0].file);
            }

            // 這裡可以發送 API 請求
            ReportService.add(formData)
                .then(response => {
                    console.log(response)
                })
                .catch(error => {
                    console.log(error)
                })

            console.log('Report content:', this.reportContent);
            console.log('Image:', this.reportImages[0]?.file);

            // 重置表單並關閉對話框
            this.closeReportDialog();
        },
        async openReportDialog() {
            try {
                // 先開啟對話框
                this.reportDialog = true;
                
                // 等待對話框開啟後再截圖
                await this.$nextTick();
                
                // 獲取 v-main 元素
                const mainElement = document.querySelector('.v-main');
                
                // 使用 html2canvas 截圖
                const canvas = await html2canvas(mainElement);
                
                // 將截圖轉換為 blob
                canvas.toBlob((blob) => {
                    // 創建預覽圖片
                    const file = new File([blob], 'screenshot.png', { type: 'image/png' });
                    const reader = new FileReader();
                    
                    reader.onload = (e) => {
                        this.reportImages = [{
                            file: file,
                            preview: e.target.result
                        }];
                    };
                    
                    reader.readAsDataURL(blob);
                }, 'image/png');
            } catch (error) {
                console.error('Screenshot failed:', error);
            }
        },
        handleImageAreaClick() {
            // 如果已經有截圖，則允許上傳新圖片
            if (this.reportImages.length > 0) {
                this.$refs.imageInput.click();
            }
        },
        checkUserType() {   
            if (localStorage.getItem('userType') != 3) {
                return window.location.reload()
            }else{
                return
            }   
        },
    },
    mounted() {
        this.init()
        window.addEventListener("focus", this.checkUserType);
        document.addEventListener("visibilitychange", this.checkUserType);
    },
    beforeDestroy() {
        window.removeEventListener("focus", this.checkUserType);
        document.removeEventListener("visibilitychange", this.checkUserType);
    }
}
</script>

<style scoped>
.v-navigation-drawer {
    background-color: #f5f5f5;
    width: 300px !important;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
}

.logo-container {
    padding: 30px;
    background-color: #000;
    color: white;
    text-align: center;
}

.logo-container h1 {
    font-size: 24px;
}

.main-menu {
    padding: 20px 10px;
    margin-bottom: 120px;
}

.bottom-fixed-menu {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #f5f5f5;
    border-top: 1px solid #e0e0e0;
}

.v-list-item {
    margin: 12px 0;
    height: 56px !important;
    border-radius: 8px;
}

.listItemIcon {
    align-self: center;
    margin-left: 12px;
}

.listIcon {
    font-size: 1.8rem !important;
}

.listTitle {
    font-size: 1.2rem !important;
    line-height: 1.2rem !important;
    text-align: left;
    font-weight: 500;
}

.v-list-item:hover {
    background-color: #e0e0e0;
}

.bottom-fixed-menu .v-list {
    padding: 30px;
}

.v-main {
    padding: 0 !important;
}

.v-card {
    border-radius: 30px;
}

.v-card-title {
    display: block;
    padding: 0;
}

.avatar-upload {
    margin-left: 16px;
}

.avatar-preview {
    cursor: pointer;
    border: 2px dashed #e0e0e0;
    background-color: #f5f5f5;
    transition: all 0.3s;
}

.avatar-preview:hover {
    border-color: #000;
    opacity: 0.8;
}

.main-content {
    padding: 20px;
    margin-left: 300px !important;
    min-height: 100vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
}

.voice-dialog {
    border-radius: 16px;
    padding: 20px;
}

.record-button-container {
    display: flex;
    justify-content: center;
    margin-top: 30px;
}

.record-button {
    transition: all 0.3s ease;
}

.record-button:hover {
    transform: scale(1.05);
}

.outliner {
    border: 2px solid #000;
    padding: 30px;
    margin: 50px;
    margin-bottom: 150px;
    height: 90%;
}

.image-upload-area {
    border: 2px dashed #e0e0e0;
    border-radius: 8px;
    padding: 16px;
    text-align: center;
}

.position-relative {
    position: relative;
}

.delete-btn {
    position: absolute;
    top: -8px;
    right: -8px;
    z-index: 1;
}

.preview-area {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    transition: background-color 0.3s;
}

.preview-area:hover {
    background-color: #1a1a1a !important;
}

.upload-hint {
    text-align: center;
}

.delete-btn {
    position: absolute;
    top: -4px;
    right: -4px;
    z-index: 1;
}

/* 防止點擊刪除按鈕時觸發上傳 */
.delete-btn:hover {
    cursor: pointer;
    z-index: 2;
}

.v-textarea >>> .v-input__slot {
    border-radius: 12px !important;
}

.image-preview {
    width: 200px;  /* 設定固定寬度 */
    height: 200px; /* 設定固定高度 */
    object-fit: cover; /* 確保圖片填滿容器且保持比例 */
    position-area: center;
}
</style>
